import React, { Component } from 'react';
import { BackgroundColors, SortOrder } from '../../../../constants/Enums';
import { firstTdStyles, fontStyles, tdStyles, theadStyles } from './styles/Table.css';
import * as PropTypes from 'prop-types';
import { trStyles } from './styles/ModalTable.css';
import PaginationItem from '../../../common/PaginationItem';
import { bindActionCreators } from 'redux';
import { updateSecurityGroup } from '../../../../actions/SecurityGroupActions';
import { connect } from 'react-redux';

class UsersTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            filteredRows: [],
            visibleRows: [],
            pageCount: 1,
            activePage: 1,
            usersPerPage: 5,
            users: []
        };
    }

    filter = (e) => {
        let rows = this.state.rows;
        let value = e.target ? e.target.value.toUpperCase() : '';
        let filteredRows = rows.filter((row) => {
            return row.name.toUpperCase().indexOf(value) > -1
        });
        this.updateRows(filteredRows);
    };

    sort = (target, order) => {
        let rows = this.state.rows;
        if (order === SortOrder.ASCENDING) {
            rows.sort((a, b) => {
                return a[target].localeCompare(b[target]);
            });
        } else {
            rows.sort((a, b) => {
                return b[target].localeCompare(a[target]);
            });
        }
        this.setState({ rows });
    };

    updateRows = (rows) => {
        const { usersPerPage } = this.state;
        const rowCount = rows.length;
        const pageCount = rowCount >= usersPerPage ? Math.ceil(rowCount / usersPerPage) : 1;
        const visibleRows = rows.slice(0, usersPerPage);
        this.setState({ filteredRows: rows, visibleRows, pageCount });
    };

    setRows = (users) => {
        const { usersPerPage } = this.state;
        let filteredRows = [];
        users.forEach(user => {
            filteredRows.push({ ...user });
        });
        const rowCount = filteredRows.length;
        let pageCount = 1;
        if (rowCount > usersPerPage) {
            pageCount = Math.ceil(rowCount / usersPerPage);
        }
        const visibleRows = filteredRows.slice(0, usersPerPage);
        this.setState({ filteredRows, rows: filteredRows, visibleRows, pageCount });
    };


    getPaginationNumbers = (pageCount) => {
        let pageNumbers = [];
        for (let i = 1; i <= pageCount; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    toggleVisibleUsers = (pageNum) => {
        if (!pageNum || pageNum > this.state.pageCount)
            return;
        const { filteredRows, usersPerPage } = this.state;
        const startIndex = (usersPerPage * pageNum) - usersPerPage;
        if (filteredRows && filteredRows.length >= startIndex) {
            const endIndex = filteredRows.length >= startIndex + usersPerPage
                ? startIndex + usersPerPage
                : filteredRows.length;
            const visibleRows = filteredRows.slice(startIndex, endIndex);
            this.setState({ visibleRows, activePage: pageNum });
        }
    };

    getPaginationItems = (pageCount) => {
        const pageNumbers = this.getPaginationNumbers(pageCount);
        let items = [];
        items.push(
            <PaginationItem key={0} action={this.toggleVisibleUsers}
                            icon={'keyboard_arrow_left'}
                            disabled={this.state.activePage === 1} pageValue={this.state.activePage - 1} />
        );
        pageNumbers.forEach((pageNumber) => {
            items.push(
                <PaginationItem key={pageNumber}
                                action={this.toggleVisibleUsers}
                                text={pageNumber}
                                pageValue={pageNumber}
                                active={this.state.activePage === pageNumber} />
            );
        });
        items.push(
            <PaginationItem key={20} action={this.toggleVisibleUsers}
                            icon={'keyboard_arrow_right'}
                            disabled={this.state.activePage === pageCount}
                            pageValue={this.state.activePage + 1} />
        );
        return items;
    };

    componentDidMount() {
        this.setState({ users: this.props.users });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.users != null && nextProps.users !== this.state.users) {
            this.setState({ users: nextProps.users });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.users && this.state.users !== prevState.users) {
            this.setRows(this.state.users);
        }
    }

    deleteUser(id) {
        let temp = [];

        let counter;
        for (counter = 0; counter < this.props.securityGroup.users.length; counter++) {
            if (this.props.securityGroup.users[counter].userId !== id) {
                temp.push(this.props.securityGroup.users[counter])
            }
        }

        this.props.securityGroup.users = temp;
        this.props.updateSecurityGroup(this.props.securityGroup);
    }

    render() {
        const getTableHeaders = () => {
            let headers = [];
            headers.push(
                <th key={1}>Name</th>
            );
            return headers;
        };

        const getTableRows = () => {
            let rows = [];
            this.state.visibleRows.forEach((row, i) => {
                rows.push(
                    <tr key={i} style={{ padding: '0' }}>
                        <td style={{ ...tdStyles(true) }}><span>{row.name}</span>
                            <button type="button" className="close" aria-label="Close" onClick={() => {
                                this.deleteUser(row.id)
                            }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                )
            });
            return rows;
        };
        const PaginationItems = this.getPaginationItems(this.state.pageCount);

        return (
            <>
                <table className="table table-striped table-hover table-bordered">
                    <thead style={theadStyles}>
                        <tr>
                            {getTableHeaders()}
                        </tr>
                        <tr style={trStyles(BackgroundColors.WHITE_SMOKE)}>
                            <td style={firstTdStyles}>
                                <input
                                    type={'text'}
                                    className={'form-control'}
                                    placeholder={'Search'}
                                    style={fontStyles}
                                    onChange={(e) => this.filter(e)}
                                />
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {getTableRows()}
                    </tbody>
                </table>
                {this.state.visibleRows.length === 0 ? null :
                    <div className={'row mt-2'}>
                        <div className={'col-lg-3 offset-lg-9 col-6 offset-6'}>
                            <nav>
                                <ul className={'pagination justify-content-end'}>
                                    {PaginationItems}
                                </ul>
                            </nav>
                        </div>
                    </div>
                }
            </>
        );
    }
}

UsersTable.propTypes = {
    users: PropTypes.array.isRequired,
    securityGroup: PropTypes.object,
    updateSecurityGroup: PropTypes.func
};

function mapStateToProps(state) {
    return {
        securityGroup: state.securityGroup.securityGroup,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ updateSecurityGroup }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersTable);